export default {"src":"/_next/static/media/appStore.a06c777b.svg","height":80,"width":250,"blurWidth":0,"blurHeight":0};